import documentCenter from '../data/documentCenterData/documentCenter.json';

export const getAllTableData = (persona: any) => {
    const data: any = documentCenter['data'];

    return data[persona];
};
